export enum FortifiedHomeCertification {
  Bronze = "FORTIFIED - Bronze",
  Gold = "FORTIFIED - Gold",
  No = "No",
  SaferLiving = "FORTIFIED - Safer Living",
  Silver = "FORTIFIED - Silver",
}
